
export default {
  scrollToClass(className) {
    let divs = document.getElementsByClassName(className)

    if (divs[0]) {
      divs[0].scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }
}
